import classnames from "classnames";
import LargeControl from "@JohnLewisPartnership/jl-design-system/dist/components/large-control/LargeControl";
import LargeControlList from "@JohnLewisPartnership/jl-design-system/dist/components/large-control/LargeControlList";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import MoreFromUs from "../../components/more-from-us/more-from-us";
import analyticsTrigger from "../../utils/analytics/trigger/analyticsTrigger";
import styles from "./index.module.scss";

export const metadata = {
  title: `Escalated Complaints | Customer Services`,
  description: `Have a question? We're here to help with all your queries, from delivery and returns to orders and your online account and your My John Lewis membership.`,
};

function Escalate() {
  const router = useRouter();
  const handleClick = option => {
    const emailUsRoute = {
      pathname: "./email-us",
      query: option === "yes" ? "mode=escalate" : null,
    };

    router.push(emailUsRoute);
  };

  useEffect(() => {
    analyticsTrigger("dataStateChange", router.pathname, {}, "pageload");
  }, []);

  return (
    <>
      <h2 className="util-pageHeading" aria-label="contact us">
        Contact us
      </h2>
      <div className="util-container">
        <h1 className={classnames("util-sectionHeading", styles.pageHeading)}>
          Sorry to hear you have had a poor experience with John Lewis
        </h1>
        <div className={styles.controlListContainer}>
          <h2 className={styles.pageQuestion}>Have you contacted us about your issue already?</h2>
          <LargeControlList onClick={option => handleClick(option)}>
            <LargeControl value="yes">
              <div className={styles.contentWrapper}>
                <strong>Yes</strong>
                <span>but I want to escalate</span>
              </div>
            </LargeControl>
            <LargeControl value="no">
              <div className={styles.contentWrapper}>
                <strong>No</strong>
                <span>I've not contacted you before</span>
              </div>
            </LargeControl>
          </LargeControlList>
        </div>
      </div>

      <div className="util-container">
        <div className={styles["contact-us__more-from-us"]}>
          <MoreFromUs />
        </div>
      </div>
    </>
  );
}

Escalate.metadata = metadata;

export default Escalate;
